import 'babel-polyfill';
import 'formdata-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { initialize, addTranslationForLanguage } from 'react-localize-redux';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';

import 'font-awesome/css/font-awesome.min.css';

import localizationFi from './localization/fi.json';
import localizationEn from './localization/en.json';
import { updateSession } from './actions/session';

import './fonts.css';
import './index.css';

import App from './App';
import store, { history } from './store';
import registerServiceWorker from './registerServiceWorker';

const languages = {
  fi: localizationFi,
  en: localizationEn,
};

store.dispatch(initialize(Object.keys(languages), { defaultLanguage: 'fi' }));

for (const language in languages) {
  store.dispatch(addTranslationForLanguage(languages[language], language));
}

store.dispatch(updateSession);

history.listen(() => {
  store.dispatch(updateSession);
});

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'),
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js